<template>
  <article class="layout-section -bg-primary">
    <div class="layout-section__hgroup">
      <h2 class="layout-section__title">{{ wp.charter.title }}</h2>
      <p>{{ wp.charter.text }}</p>
    </div>

    <div class="rte" v-html="wp.charter.content" />
  </article>
</template>

<script>
export default {
  name: 'AboutCharte',
  inject: ['wp']
}
</script>
